import { DetailedGameRound } from '@/models/detailed-round';
import { GenericError } from '@/models/generic-error';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { GameRoundQueryKeys } from '../../queryKeys';
import {
  UseCurrentGameRoundByGameIdProps,
  UseCurrentGameRoundByGameIdQueryKey,
} from './props';
import { fetchCurrentGameRoundByGameId } from './service';

export function useCurrentGameRoundByGameId(
  options?: UseCurrentGameRoundByGameIdProps,
) {
  const { gameId } = options ?? {};

  const queryKey: UseCurrentGameRoundByGameIdQueryKey = [
    GameRoundQueryKeys.ByGameId,
    { gameId },
  ];

  const { data, fetchStatus, ...infinityQuery } = useQuery<
    DetailedGameRound,
    AxiosError<GenericError>,
    DetailedGameRound,
    UseCurrentGameRoundByGameIdQueryKey
  >({
    queryKey,
    queryFn: fetchCurrentGameRoundByGameId,
    enabled: !!gameId,
    staleTime: 5 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    ...infinityQuery,
    round: data,
    isLoading: infinityQuery.isPending && fetchStatus !== 'idle',
    error: infinityQuery.error as AxiosError<GenericError>,
  };
}
